import {
  _increment,
  production_type,
  job_no,
  unit,
  heat_treatment,
  surface_treatment,
} from '@/table/Job/SubJob/base';
import useSubJob from '@/use/useSubJob';

const {
  qcStatusClassMap,
  translateQCStatus,
} = useSubJob();

export default {
  types: {
    _increment,
    production_type,
    job_no: {
      ...job_no,
      width: '1fr',
    },
    currentStatusAmount: {
      name: 'ทั้งหมด / ปัจจุบัน',
      width: '8rem',
      class: 'text-center',
    },
    addonAmount: {
      name: 'จำนวนเพิ่มเติม',
      width: '6rem',
      class: 'text-center',
    },
    unit,
    status: {
      name: 'สถานะปัจจุบัน',
      width: '8rem',
      filter: (val: string, row: any) => translateQCStatus(row.item.qc_status),
      class: {
        text: (val: string, row: any) => qcStatusClassMap(row.item.qc_status),
      },
    },
    heat_treatment,
    surface_treatment,
  },
};
